/* ------------- Reducers ------------- */

import {
  SET_MOBILE_MENU,
} from "../actions/header";

const initialState = {
  mobileMenu: false,
};

export const headerReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_MOBILE_MENU:
      return Object.assign({}, state, payload);

    default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/header.js